"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountHierarchyType = exports.ArrayType = void 0;
var ArrayType;
(function (ArrayType) {
    ArrayType["ALL"] = "ALL";
    ArrayType["PROD"] = "Customer - Production";
    ArrayType["POC"] = "POC";
})(ArrayType || (exports.ArrayType = ArrayType = {}));
var AccountHierarchyType;
(function (AccountHierarchyType) {
    AccountHierarchyType["SFDC"] = "SFDC";
    AccountHierarchyType["PURE"] = "PURE";
})(AccountHierarchyType || (exports.AccountHierarchyType = AccountHierarchyType = {}));
//# sourceMappingURL=LoadRequest.js.map